import { render, staticRenderFns } from "./usappchiefver.vue?vue&type=template&id=2b93b610&scoped=true&"
import script from "./usappchiefver.vue?vue&type=script&lang=js&"
export * from "./usappchiefver.vue?vue&type=script&lang=js&"
import style0 from "./usappchiefver.vue?vue&type=style&index=0&id=2b93b610&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b93b610",
  null
  
)

export default component.exports